import { parse, stringify } from 'devalue';

export const devalueTransformer = {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  deserialize: (object: any) => parse(object),
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  serialize: (object: any) => stringify(object),
};
